import React from "react";

export const Slider = ({ value, min, max, step, onChange, ariaLabel }) => {
  const pct = ((value - min) / (max - min)) * 100;
  return (
    <input
      type="range"
      className="mm-slider"
      min={min}
      max={max}
      step={step}
      value={value}
      onChange={(e) => onChange(Number(e.target.value))}
      style={{ "--mm-progress": `${pct}%` }}
      aria-label={ariaLabel}
    />
  );
};

export const InputRow = ({ label, valueText, children, finePrint, valueTestId }) => (
  <div className="mb-7">
    <div className="flex items-center justify-between gap-3">
      <label style={{ color: "#4A5568", fontSize: 14, fontWeight: 500 }}>{label}</label>
      <span
        className="font-mono-fin font-semibold text-right"
        style={{ color: "#1A202C", fontSize: 16 }}
        data-testid={valueTestId}
      >
        {valueText}
      </span>
    </div>
    <div className="mt-3">{children}</div>
    <div className="mt-2 flex justify-between" style={{ color: "#718096", fontSize: 12 }}>
      {finePrint}
    </div>
  </div>
);

export const ResultRow = ({ label, value, valueColor = "#FFFFFF", testId }) => (
  <div className="flex items-center justify-between" data-testid={testId}>
    <span style={{ color: "#718096", fontSize: 13 }}>{label}</span>
    <span className="font-mono-fin" style={{ color: valueColor, fontSize: 13 }}>
      {value}
    </span>
  </div>
);

export const SplitBar = ({ leftPct, rightPct, leftLabel, rightLabel, leftColor, rightColor, testId }) => (
  <div>
    <div
      className="w-full overflow-hidden flex"
      style={{ height: 8, borderRadius: 9999, backgroundColor: "rgba(255,255,255,0.08)" }}
      data-testid={testId}
    >
      <div style={{ width: `${leftPct}%`, backgroundColor: leftColor, transition: "width 200ms ease" }} />
      <div style={{ width: `${rightPct}%`, backgroundColor: rightColor, transition: "width 200ms ease" }} />
    </div>
    <div className="flex items-center justify-between mt-3" style={{ fontSize: 12 }}>
      <div style={{ color: leftColor }} className="font-mono-fin">
        {leftLabel} {leftPct.toFixed(0)}%
      </div>
      <div style={{ color: rightColor }} className="font-mono-fin">
        {rightLabel} {rightPct.toFixed(0)}%
      </div>
    </div>
  </div>
);

export const DarkCTA = ({ href, children, testId }) => (
  <a
    href={href}
    className="mt-8 inline-flex items-center justify-center w-full rounded-lg font-semibold text-white transition-colors"
    style={{ backgroundColor: "#1D9E75", fontSize: 14, padding: "12px 20px" }}
    onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = "#0F6E56")}
    onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = "#1D9E75")}
    data-testid={testId}
  >
    {children}
  </a>
);

export const Pills = ({ items, value, onChange, prefix }) => (
  <div className="flex flex-wrap gap-2">
    {items.map((t) => {
      const active = value === t;
      return (
        <button
          key={t}
          type="button"
          onClick={() => onChange(t)}
          className="rounded-full transition-all duration-150"
          style={{
            fontSize: 13,
            fontWeight: 500,
            padding: "8px 14px",
            backgroundColor: active ? "#1D9E75" : "#F7F9FC",
            color: active ? "#FFFFFF" : "#4A5568",
            border: active ? "1px solid #1D9E75" : "1px solid #E2E8F0",
          }}
          data-testid={`${prefix}-${t.toLowerCase().replace(/\s+/g, "-").replace(/[^a-z0-9-]/g, "")}`}
        >
          {t}
        </button>
      );
    })}
  </div>
);

export const RightPanel = ({ children, testId }) => (
  <div
    className="p-6 sm:p-10 rounded-b-2xl lg:rounded-bl-none lg:rounded-r-2xl"
    style={{ backgroundColor: "#0D1117" }}
    data-testid={testId}
  >
    {children}
  </div>
);

export const Divider = () => (
  <div className="my-6" style={{ height: 1, backgroundColor: "rgba(255,255,255,0.08)" }} />
);

export const HeroValue = ({ label, value, animKey, testId }) => (
  <>
    <div className="uppercase" style={{ color: "#718096", fontSize: 12, letterSpacing: "0.1em" }}>
      {label}
    </div>
    <div
      key={animKey}
      className="font-mono-fin font-bold text-white mt-2 animate-mm-fade"
      style={{ fontSize: 36, lineHeight: 1.1 }}
      data-testid={testId}
    >
      {value}
    </div>
  </>
);
